import React from "react";
import styled from "styled-components";
import { get } from "lodash";
import { CardCategory } from "./CardTitleOverImage";
import { colors } from "../../helpers";
import { IonContent } from "@ionic/react";
export default ({ theme, data, currentCategory, setCurrentCategory, components }) => {
    return (React.createElement(React.Fragment, null, currentCategory ? components() :
        React.createElement(IonContent, { fullscreen: true },
            React.createElement(WrapperCategories, { color: colors[get(theme, 'color.background')], scrollable: true, mode: "md" }, data.map((value, i) => (React.createElement(CardCategory, { theme: theme, key: value.id, setCurrentCategory: setCurrentCategory, id: value.id, name: value.name, picture: value.picture })))))));
};
const WrapperCategories = styled.div `
  flex-wrap: wrap;
  align-items: center;
  background-color: ${props => props.color};
  overflow-y: hidden;
  display:flex;
  flex-wrap: wrap;
  padding:10px;
  height: 90%;
  overflow: scroll;
  justify-content: space-evenly;
  align-content: flex-start;
`;
